import React from "react";
import {Consume} from "../Context/Consumer";
import {TransContext} from "../Context";
import config from "../common/config";
import {getTrans} from "../common";

const Loader = props => {
	return (
		<div className='pg-loader__wrap si-active' style={props.style}>
			<div className='si-hex'>
				<img
					src={`${config.IMG_BASE}loading.gif`}
					alt={getTrans(props.TransData.data, "loading", "Loading")}
				/>
			</div>
			<div className='si-hex__lbl'>
				<span style={props.textStyle}>{getTrans(props.TransData.data, "loading", "Loading")}</span>
			</div>
		</div>
	);
};

export default Consume(Loader, [TransContext]);
